// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__m2Dft","centerColumn":"layout_centerColumn__jdhba"};